import axios from 'axios'

export default {
    getProductsByCategory(categoryId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/categories/' + categoryId + '/products').then((response) => {
            return response
        })
    },
    getProductsByInput(input) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/products/input/' + encodeURIComponent(input)).then((response) => {
            return response
        })
    },
    createProduct(product) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/products', product).then((response) => {
            return response
        })
    },
    getProduct(productId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/products/' + productId).then((response) => {
            return response
        })
    },
    editProduct(product) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/products', product).then((response) => {
            return response
        })
    },
    deleteProduct(productId) {
        return axios.delete(process.env.VUE_APP_BACKEND_BASE_URL + '/products/' + productId).then((response) => {
            return response
        })
    },
    toggleProductActivation(payload) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/products/toggleActivation/' + payload.productId, payload).then((response) => {
            return response
        })
    },
    getCategoryCodes() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/products/distinct/categoryCodes').then((response) => {
            return response
        })
    },
    importProducts(products) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/products/import', products).then((response) => {
            return response
        })
    },
    toggleProductStar(payload) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/products/toggleStar/' + payload.productId, payload).then((response) => {
            return response
        })
    },
    getStarProduct() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/product/star').then((response) => {
            return response
        })
    },
    toggleProductOffer(payload) {
        return axios.put(process.env.VUE_APP_BACKEND_BASE_URL + '/products/toggleOffer/' + payload.productId, payload).then((response) => {
            return response
        })
    },
    getOfferProducts() {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/products/offer').then((response) => {
            return response
        })
    }
}
